import React, { Component } from 'react';
import PropTypes from 'prop-types';
import create360Viewer from '360-image-viewer';
import canvasFit from 'canvas-fit';
 
class Viewer360 extends Component{
    
    constructor(props){
        super(props);
        
        this.state = {
            image: null,
            viewer: null,
            fadeIn: false,
            zoom: 0
        }

        this.canvasRef = React.createRef();
        this.fit = null;
        this.viewer = null;

        this.viewerRef = null;
        this.phi = 0;
        this.theta = 0;

        this._isMounted = false;
    }

    componentDidMount(){

        this._isMounted = true;
        //console.log('mounted 360')
        this.setState(prevState => ({
            image: this.props.path
            
        }))
    }

    componentWillUnmount() {
        this._isMounted = false;        
    }

    componentDidUpdate( prevProps, prevState){
        
        if(this.state.path !== this.props.path){

            if(prevState.image === this.props.path){
                return;
            }
            
            this.setState({
                image: this.props.path
            },
            ()=> {
                
            })

            const image = new Image();
            image.src = this.props.path;
            
            image.onload = () => {

                // when the image is loaded, setup the viewer
                this.viewerRef = create360Viewer({
                    image: image,
                    canvas: this.canvasRef.current,
                    theta: - Math.PI / 2,
                    phi: Math.PI * .485,
                    rotateSpeed: -0.15,
                    fov: 62 * Math.PI / 180
                });
                
                if(this.props.hasControl){
                    this.viewerRef.on('tick', (dt)=>{
                        //if(i % 2 === 0){
                        if(!this._isMounted){
                            return;
                        }
                        if(Math.abs(this.phi - this.viewerRef.controls.phi) > 0.001 || 
                            Math.abs(this.theta - this.viewerRef.controls.theta) > 0.001){
                                this.props.update360Tour({
                                    phi: this.viewerRef.controls.phi, 
                                    theta: this.viewerRef.controls.theta
                                });
                                //console.log('*** controls:', this.viewerRef.controls)
                        }                       
                            
                            
                            //console.log('*** phi:', this.viewerRef.controls.phi)
                            //console.log('*** theta:', this.viewerRef.controls.theta)
                        //}                
                    })
                }
                // setup fullscreen canvas sizing
                if(!this.fit){
                    this.fit = canvasFit(this.viewerRef.canvas, window, window.devicePixelRatio);
                    window.addEventListener('resize', this.fit, false);
                    this.fit();
                }
                
                // start the render loop
                this.viewerRef.start();

                window.addEventListener('wheel', e => {
                    this.setState(prevState => ({
                        zoom: prevState.zoom + e.deltaY
                    }),
                    () => {
                        this.viewerRef.camera.fov = this.state.zoom * Math.PI / 180
                        //console.log(this.state.zoom, this.viewerRef)
                        //this.viewerRef.render()
                    })
                })
            
                this.setState({
                    fadeIn: true
                })
                this.props.onReady();
            };
        }
    }

    updateDirectionFromTour = (direction)=>{
        console.log('update direction from tour:', this.viewerRef, direction)
        if(this.viewerRef){
            this.viewerRef.controls.phi = direction.phi
            this.viewerRef.controls.theta = direction.theta
            //this.viewerRef.camera.
        }
    }

    render() {
        return (
            <div>
                <canvas 
                className={this.state.fadeIn ? "canvas360 fadeIn" : 'canvas360'}
                ref={this.canvasRef}
                />
            </div>
        );
      
    }
}

Viewer360.propTypes = {
    path: PropTypes.string,
    onReady: PropTypes.func
}

Viewer360.defaultProps = {
    path: undefined,
    onReady: () => {}
}

export default Viewer360;